export const CountiesType={
    chiayistudy:'嘉義縣',
    yunlinstudy:'雲林',
}